(() => {
  const script = document.currentScript;
  const country = (script?.dataset.country || '').toUpperCase();
  const messages = {
    en: 'Your next favorite look awaits ✦ AKUMA CLUB',
    de: 'Dein nächster Lieblingslook wartet ✦ AKUMA CLUB',
    es: 'Tu próximo look favorito te espera ✦ AKUMA CLUB',
    fr: 'Ton prochain look préféré t’attend ✦ AKUMA CLUB',
    it: 'Il tuo prossimo look preferito ti aspetta ✦ AKUMA CLUB'
  };
  const language = (script?.dataset.language || '').toLowerCase().split('-')[0];
  const fallback = ['DE', 'AT', 'CH'].includes(country) ? 'de' : 'en';
  const message = messages[language] || messages[fallback];
  const desktop = matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const characters = Array.from(message + '　 •　 ');
  let originalTitle = '';
  let hiddenAt = null;
  let timer;
  let position = 0;
  let showingReminder = false;

  function reset() {
    clearTimeout(timer);
    if (showingReminder) document.title = originalTitle;
    showingReminder = false;
    hiddenAt = null;
    position = 0;
  }

  function tick() {
    if (!document.hidden || !desktop.matches) {
      reset();
      return;
    }
    const remaining = 60000 - (Date.now() - hiddenAt);
    if (remaining > 0) {
      timer = setTimeout(tick, remaining);
      return;
    }
    showingReminder = true;
    position = Math.floor(Math.max(0, Date.now() - hiddenAt - 60000) / 500) % characters.length;
    document.title = reducedMotion.matches ? message
      : characters.slice(position).concat(characters.slice(0, position)).join('');
    if (!reducedMotion.matches) {
      // Derive the position from elapsed time so delayed callbacks do not slow the message.
      // Background timers can be delayed by the browser; never bypass its throttling.
      timer = setTimeout(tick, 500);
    }
  }

  function visibilityChanged() {
    if (!document.hidden || !desktop.matches) {
      reset();
    } else if (hiddenAt === null) {
      originalTitle = document.title;
      hiddenAt = Date.now();
      timer = setTimeout(tick, 60000);
    }
  }
  document.addEventListener('visibilitychange', visibilityChanged);
  desktop.addEventListener('change', visibilityChanged);
  reducedMotion.addEventListener('change', () => {
    if (showingReminder) {
      clearTimeout(timer);
      tick();
    }
  });
  window.addEventListener('pagehide', reset);
  window.addEventListener('pageshow', visibilityChanged);
  visibilityChanged();
})();
